import ArticleRankingSlider from './ArticleRankingSlider';
import ArticleSimpleSlider from './ArticleSimpleSlider';
import ArticleSlider from './ArticleSlider';
import FeaturedSlider from './FeaturedSlider';
import LatestArticles from './LatestArticles';
import NewspaperCategorySlider from './NewspaperCategorySlider';
import NewspaperStatic from './NewspaperStatic';
import NewspaperUnique from './NewspaperUnique';

function getArticleCollectionProps(collection) {
  return {
    articles: collection.collection_articles,
    category: collection.collection_name,
    link: `/newspaper/${collection.collection_url}`,
  };
}

function renderArticleSlider(collection) {
  return (
    <ArticleSlider
      articles={collection.collection_articles}
      category={collection.collection_name}
      link={`/newspaper/${collection.collection_url}`}
      image={collection.cover_image}
    />
  );
}

const collectionSectionRenderers = {
  'newspaper-latest': collection => (
    <LatestArticles {...getArticleCollectionProps(collection)} />
  ),
  'newspaper-static': collection => (
    <NewspaperStatic {...getArticleCollectionProps(collection)} />
  ),
  'newspaper-unique': collection => (
    <NewspaperUnique {...getArticleCollectionProps(collection)} />
  ),
  'newspaper-featured': collection => (
    <FeaturedSlider {...getArticleCollectionProps(collection)} />
  ),
  'newspaper-ranking': collection => (
    <ArticleRankingSlider
      articles={collection.collection_articles}
      rankingPeriod={collection.ranking_period}
      category={collection.collection_name}
    />
  ),
  'newspaper-categories': collection => (
    <NewspaperCategorySlider
      categories={collection.collection_internalcols}
    />
  ),
  'newspaper-simple': collection => (
    <ArticleSimpleSlider
      {...getArticleCollectionProps(collection)}
    />
  ),
};

export default function renderCollectionSection(collection) {
  const renderSection = collectionSectionRenderers[collection.type] || renderArticleSlider;
  return renderSection(collection);
}
